import { styled, Typography } from "@mui/material";
import React from "react";

export const BoxCustom = styled("div")({
    width: "100%",
    border: `2px solid #DDE1EB`,
    borderRadius: "16px 16px 0px 0px",
    minHeight: 800,
    maxHeight: 800,
    height: '100%',
    padding: "40px",
    flexDirection: 'column',
    justifyContent: "space-between",
    overflow: "auto"
})


type containerBox = {
    title_name: string;
    content?: React.ReactNode;
    footer?: React.ReactNode;
}
export const ContainerBox = ({ title_name, content, footer }: containerBox) => {

    return (
        <div className="w-full h-full">
            <BoxCustom>
                <div>
                    <Typography fontWeight={600} variant="h4" sx={{ color: "#333333" }}>
                        {title_name}
                    </Typography>
                </div>
                <div className="w-full">
                    {content}
                </div>
            </BoxCustom>
            <div className="h-auto p-4 lg:p-0 lg:h-[100px] flex justify-center items-center rounded-b-[16px] bg-[#DDE1EB]">
                {footer}
            </div>
        </div>
    )
}